import { object, string, ref, number, array, bool } from "yup";
const phoneRegExp = /^\d{11}$/;
// const digitsOnly = (value: any) => /^\d+$/.test(value);
const getCharacterValidationError = (str: string) => {
  return `Your password must have at least 1 ${str} character`;
};
export const authSchema = {
  login: object().shape({
    email: string()
      .email("Enter a Valid Email Address")
      .required("Email is Required"),
    password: string()
      .min(4, "Password too short")
      .max(40, "oops, too long")
      .required("Password is required"),
  }),
  forgotPassword: object().shape({
    email: string()
      .email("Enter a Valid Email Address")
      .required("Email is Required"),
  }),
  resetPassword: object().shape({
    newPassword: string()
      .min(8, "Password is too short")
      .strict(true)
      .trim("White Space not allowed !")
      .max(30, "Password is too long")
      .matches(/[0-9]/, getCharacterValidationError("digit"))
      .matches(/[a-z]/, getCharacterValidationError("lowercase"))
      .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
      .matches(/[!@#$%^&*()_+]+/, getCharacterValidationError("special"))
      .required("Password is required"),
    confirmPassword: string()
      .strict(true)
      .trim("White Space not allowed !")
      .oneOf([ref("newPassword"), null], "Passwords don't match")
      .required("Confirm Password is required"),
  }),
  register: object().shape({
    firstName: string()
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .matches(/^\S*$/, "First name field must be without spaces")
      .min(1, "First Name too short")
      .max(40, "oops, too long")
      .strict(true)
      .trim("White Space not allowed !")
      .required("First Name is required"),
    lastName: string()
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .matches(/^\S*$/, "Last name field must be without spaces")
      .min(1, "Last Name too short")
      .max(40, "oops, too long")
      .strict(true)
      .trim("White Space not allowed !")
      .required("Last Name is required"),
    email: string()
      .min(2, "email is too short")
      .email("Enter email")
      .required("Email is Required"),
    businessName: string()
      .min(2, "Business name is too short")
      .max(50, "")
      .required("Business name is Required"),
    // state: string().required("State is required"),
    // city: string().required("City is required"),
    phoneNumber: string()
      .matches(phoneRegExp, "Phone number is not valid")
      .min(11, "Phone number is too short")
      .max(11, "enter a valid phone number")
      .required("Phone Number is required"),
    saFcurrentAccount: string()
      .min(10, "Account Invalid")
      .max(10, "Invalid Account Number")
      .required("The Alternative Bank current Account required"),
    // password: string()
    //   .min(6, "Password is too short")
    //   .max(30, "")
    //   .required("Enter a password"),
    // confirmPassword: string()
    //   .oneOf([ref("password"), null], "Passwords don't match")
    //   .required("Confirm Password is required"),
    categoryOfProduct: array()
      .min(1, "At least one option is required")
      .required("Product Category is required"),
    referral_Code : string()
  }),
  kyc: object().shape({
    // uploadImage: string().required("Image not Uploaded"),
    representativeName1: string().required("Representative 1 Name is required"),
    representativeName2: string().required("Representative 2 Name is required"),
    dateofRegistration: string().required("Date of Registration is required"),
    cacRegistrationNumber: string().required(
      "CAC Registration Number is required"
    ),
    operationLocation: array()
      .min(1, "At least one option is required")
      .required(),
    // .of(
    //   object().shape({
    //     key: string().required("select a local government"),
    //     value: string().required("select a local government"),
    //     label: string().required("select a local government"),
    //   })
    // )
    // .nullable()
    // .required("This field is required."),
    accountNumber: string().required("Account Number is required"),
    accountName: string().required("Account Name is required"),
    // bvn: string().required("BVN is required"),
    // acctPhoneNumber: string().required("Phone Number is required"),
  }),
};

export const vendorSchema = {
  product: object().shape({
    productName: string().required("Product Name is required"),
    longDescription: string().required("Product Description is required"),
    buyerNote: string().required("Buyer's note is required"),
    categoryId: string().required("Category is required"),
    batType: string().when("category", {
      is: (category: string) => category === "Inverters",
      then: string().required("Field is required"),
      otherwise: string(),
    }),
    minIvtCap: number().when("category", {
      is: (category: string) => category === "Inverters",
      then: number()
        .required("Capacity is required")
        .test(
          "Is positive?",
          "The number must be greater than 0!",
          (value) => value! > 0
        ),
      otherwise: number(),
    }),
    batTypeValue: number().when("category", {
      is: (category: string) => category === "Inverters",
      then: number()
        .required("Type value is required")
        .test(
          "Is positive?",
          "The number must be greater than 0!",
          (value) => value! > 0
        ),
      otherwise: number(),
    }),
    productQuantity: string()
      .required("Quantity is required")
      .test(
        "Is positive?",
        "Quantity must be greater than 0!",
        (value) => Number.parseFloat(value!?.split(",")?.join("")) > 0
      ),
    productCurrentPrice: string()
      .required("Price is required")
      .test(
        "Is positive?",
        "Price must be greater than 0!",
        (value) => Number.parseFloat(value!?.split(",")?.join("")) > 0
      ),
    weight: string()
      // .typeError("Weight must be a number")
      .required("Weight is required")
      .test(
        "Is positive?",
        "Weight must be greater than 0!",
        (value) => Number.parseFloat(value!?.split(",")?.join("")) > 0
      ),
    // location: string().required("Location is required"),
    isDeliveryCarryOut: bool().required("Field is required"),
  }),
  personalSettings: object().shape({
    // storeName: string()
    //   .min(1, "Store Name too short")
    //   .max(60, "oops, too long")
    //   .required("Store Name is required"),
    password: string()
      // .required("Enter a password")
      .min(8, "Password is too short")
      .strict(true)
      .trim("White Space not allowed !")
      .max(30, "Password is too long")
      .matches(/[0-9]/, getCharacterValidationError("digit"))
      .matches(/[a-z]/, getCharacterValidationError("lowercase"))
      .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
      .matches(/[!@#$%^&*()_+]+/, getCharacterValidationError("special")),
  }),
  storeSettings: object().shape({
    // storeName: string()
    //   .min(4, "Address too short")
    //   .required("Store Address is Required"),
    storeAddress: string()
      .min(4, "Address too short")
      .required("Store Address is Required"),
    storeInformation: string()
      .min(4, "Info too short")
      .required("Store Info is Required"),
    state: string().required("State is required"),
    city: string().required("City is required"),
  }),
  subAdmin: object().shape({
    name: string()
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .min(1, "Frist Name too short")
      .max(40, "oops, too long")
      .strict(true)
      .trim("White Space not allowed !")
      .required("First Name is required"),
    lastName: string()
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .min(1, "Last Name too short")
      .max(40, "oops, too long")
      .strict(true)
      .trim("White Space not allowed !")
      .required("Last Name is required"),
    email: string()
      .min(2, "email is too short")
      .email("Enter email")
      .required("Email is Required"),
    vendorRoleId: string().required("Role is required"),
    phoneNumber: string()
      .min(11, "Phone number is too short")
      .max(11, "enter a valid phone number")
      .required("Phone Number is required")
      .matches(phoneRegExp, "Phone number is not valid"),
    password: string()
      .required("Enter a password")
      .strict(true)
      .trim("White Space not allowed !")
      .min(8, "Password is too short")
      .max(30, "Password is too long")
      .matches(/[0-9]/, getCharacterValidationError("digit"))
      .matches(/[a-z]/, getCharacterValidationError("lowercase"))
      .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
      .matches(/[!@#$%^&*()_+]+/, getCharacterValidationError("special")),
    // addProducts: bool().required("Field is required"),
    // addUsers: bool().required("Field is required"),
    // viewOrders: bool().required("Field is required"),
    // tickets: bool().required("Field is required"),
    // shipping: bool().required("Field is required"),
    // settings: bool().required("Field is required"),
  }),
  ticket: object().shape({
    title: string()
      .min(4, "Title too short")
      .required("Ticket Title is Required"),
    message: string()
      .min(4, "Message too short")
      .required("Message is Required"),
  }),
  locationInfo: object().shape({
    returnLocations: array(
      object().shape({
        address: string()
          .min(4, "Address too short")
          .max(50, "Address is too long")
          .required("Address is Required"),
        city: string()
          .min(2, "City name too short")
          .required("City is Required"),
        state: string()
          .min(1, "State name Invalid")
          .required("State is Required"),
      })
    ),
  }),
  locationInfoUpdate: object().shape({
    address: string()
      .min(4, "Address too short")
      .max(50, "Address is too long")
      .required("Address is Required"),
    city: string().min(2, "City name too short").required("City is Required"),
    state: string().min(1, "State name Invalid").required("State is Required"),
  }),
  shippingStateSettings: object().shape({
    shippingPriceList: array(
      object().shape({
        fiveKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
        tenKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
        twentyFiveKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
        aboveKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
      })
    ),
  }),
  shippingRegionSettings: object().shape({
    shippingPriceList: array(
      object().shape({
        fiveKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
        tenKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
        twentyFiveKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
        aboveKgPrice: number()
          .typeError("Price must be a number")
          .required("Price is required")
          .test(
            "Is positive?",
            "Value must not be lesser than 0!",
            (value) => value! >= 0
          ),
      })
    ),
  }),
  // locationInfo: array(
  //   object().shape({
  //     address: string()
  //       .min(4, "Address too short")
  //       .required("Address is Required"),
  //     city: string().min(2, "Info too short").required("City is Required"),
  //     state: string().min(1, "Info too short").required("State is Required"),
  //   })
  // ),
};
